<template>
    <doughnut :options="options" :data="data" />
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'
    import {Chart as ChartJS, ArcElement, Tooltip, Legend} from 'chart.js'
    import {Doughnut} from 'vue-chartjs'

    ChartJS.register(ArcElement, Tooltip, Legend)

    @Component({
        components: {
            Doughnut,
        },
    })
    export class DoughnutChart extends Vue {
        @Prop({default: () => ({}), type: Object}) data
        // @Prop({default: 'title', type: String}) titleText

        options = {
            plugins: {
                legend: {
                    position: 'left',
                    // TODO: check on vue-chartjs v5.x.x
                    // title: {
                    //     text: this.$t(this.titleText),
                    //     display: true,
                    //     font: {
                    //         size: 16,
                    //     },
                    // },
                },
            },
            responsive: true,
            maintainAspectRatio: false,
        }
    }

    export default DoughnutChart
</script>
